interface drawOptions {
    resultData: any;
    userInfo: any;
    sucessCallback: (url: string) => void;
    errCallback: () => void;
}

export default class Draw {
    public options: null | drawOptions = null
    public result: string = ''
    public fontFamily: string = '"Helvetica", "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif'

    constructor (options: drawOptions) {
        this.options = options
        this.init()
    }

    init () {
        const options = this.options as drawOptions
        const c: HTMLCanvasElement = document.createElement('canvas')
        const ctx = c.getContext('2d') as CanvasRenderingContext2D
        const ercodeImg: string = window.location.href.indexOf('demo-activity.fm-dev.thecover.cn') > -1 ? require('@/assets/img/code.png') : require('@/assets/img/code_online.png') 
        Promise.all([this.loadImage(require('@/assets/img/share_bg.jpg')), this.loadImage(ercodeImg), this.loadImage(options.userInfo.avatar), this.loadImage(require('@/assets/img/share_prize_bg.png'))]).then((imgs: any) => {
            c.width = imgs[0].width
            c.height = imgs[0].height
            ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, c.width, c.height)
            ctx.fillStyle = '#e7596f'
            ctx.arc(539, 1195, 107, 0, 2 * Math.PI, false)
            ctx.fill()
            this.drawCircleImg(ctx, imgs[2], 440, 1095, 100)
            ctx.font = `48px ${this.fontFamily}`
            ctx.textAlign = 'center'
            ctx.textBaseline = 'top'
            ctx.fillStyle = '#030303'
            ctx.fillText(options.userInfo.nickname, c.width / 2, 1345)
            if (options.resultData.prizeName) {
                ctx.drawImage(imgs[3], 0, 0, imgs[3].width, imgs[3].height, 171, 1475, imgs[3].width, imgs[3].height)
                ctx.font = `bold 48px ${this.fontFamily}`
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'
                ctx.fillStyle = '#ea5d6b'
                ctx.fillText(options.resultData.prizeName, c.width / 2, 1680)
            } else {
                const w = ctx.measureText(options.resultData.blessing).width
                const color = ctx.createLinearGradient(c.width / 2 - w / 2 - 36, 1546, c.width / 2 + w / 2 + 36, 1546 + 95)
                color.addColorStop(0, '#eb815b')
                color.addColorStop(1, '#d7573d')
                this.drawCircleRect(ctx, c.width / 2 - w / 2 - 36, 1546, w + 72, 95, 50, color)
                ctx.font = `bold 44px ${this.fontFamily}`
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'
                ctx.fillStyle = '#fff'
                ctx.fillText(options.resultData.blessing, c.width / 2, 1594)
            }
            ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 0, 1751, imgs[1].width, imgs[1].height)
            this.result = c.toDataURL('image/jpeg')
            options.sucessCallback(this.result)
        }).catch((err) => {
            options.errCallback()
        })
    }

    // 加载图片
    loadImage (url: string) {
        return new Promise((resolve) =>{
            const img = new Image()
            img.crossOrigin = 'Anonymous' 
            img.src = url
            img.addEventListener('load', () => {
                resolve(img)
            })
        })
    }

    // 画头像
    drawCircleImg ( ctx: CanvasRenderingContext2D, img: HTMLImageElement, x: number, y: number, r: number) {
        ctx.save()
        ctx.beginPath()
        ctx.arc(x + r, y + r, r, 0, 2 * Math.PI, false)
        ctx.closePath()
        ctx.fill()
        ctx.clip()
        ctx.drawImage(img, x, y, 2 * r, 2 * r)
        ctx.restore()
    }

    // 绘制圆角矩形
    drawCircleRect (ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, color: string | CanvasGradient) {
        ctx.save()
        ctx.beginPath()
        ctx.fillStyle=color;
        ctx.arc(x + r, y + r, r, Math.PI, Math.PI*1.5)
        ctx.arc(x + w - r, y + r, r, Math.PI * 1.5, Math.PI * 2)
        ctx.arc(x + w - r, y + h - r, r, 0, Math.PI * 0.5)
        ctx.arc(x + r, y + h - r, r, Math.PI * 0.5, Math.PI)
        ctx.closePath()
        ctx.fill()
        ctx.clip()
        ctx.restore()
    }

    writeText (c: HTMLCanvasElement, ctx: CanvasRenderingContext2D, text: string, textStyle: any, width: number, left: number, top: number, height: number, lineHeight: number) {
        let lastIndex = 0
        let lineCount = 0
        let line = ''
        ctx.font = `${textStyle.font} ${this.fontFamily}`
        ctx.textBaseline = textStyle.align
        ctx.textAlign = textStyle.baseline
        ctx.fillStyle = textStyle.color
        while (ctx.measureText(text).width > width) {
            for (let i = 0; ctx.measureText(text.slice(0, i)).width < width && i < text.length; i++) {   
                lastIndex = i
            }
            lastIndex = this.getIndex(lastIndex, text)
            line = text.slice(0, lastIndex)
            text = text.slice(lastIndex, text.length)
            const space = (width - ctx.measureText(line).width) / lastIndex
            const lineArr = line.split('')
            for (let i = 0; i < lineArr.length; i++) {
                let newLeft = i > 0 ? left + ctx.measureText(line.slice(0, i)).width + i * space : left
                ctx.fillText(lineArr[i], newLeft, top + lineHeight * lineCount)
            }
            lineCount++
        }
        ctx.fillText(text, left, top + lineHeight * lineCount)
        return top + lineHeight * (lineCount + 1)
    }
    
    getIndex (i, text) {
        if (['，', '“', '”', '！', '、'].indexOf(text[i]) > -1) {
            return this.getIndex(i - 1, text)
        } else {
            return i
        }
    }
}
